import { MessageCircle, MessageSquare, Mail } from "lucide-react"

// Channels = the tab structure (WhatsApp / SMS / Email).
export const CHANNELS = [
  { value: "whatsapp", label: "WhatsApp", icon: MessageCircle, badge: "bg-emerald-100 text-emerald-800" },
  { value: "sms", label: "SMS", icon: MessageSquare, badge: "bg-sky-100 text-sky-800" },
  { value: "email", label: "Email", icon: Mail, badge: "bg-violet-100 text-violet-800" },
]

export const CHANNEL_MAP = Object.fromEntries(CHANNELS.map((c) => [c.value, c]))

// Category = the entity a template is about (drives the variable picker).
export const CATEGORIES = [
  { value: "lead", label: "Lead" },
  { value: "contact", label: "Contact" },
  { value: "property", label: "Property" },
  { value: "customer", label: "Customer" },
  { value: "generic", label: "Generic" },
]

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.value, c]))

export const STATUSES = [
  { value: "active", label: "Active", badge: "bg-emerald-100 text-emerald-800" },
  { value: "draft", label: "Draft", badge: "bg-slate-100 text-slate-600" },
  { value: "archived", label: "Archived", badge: "bg-slate-100 text-slate-500" },
]

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.value, s]))
